import "./axiosSetup";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installSharedSession } from './sharedSession';
import { installClientErrors } from './platform/clientErrors';

// One login for nummius.com and academy.nummius.com (before anything reads the session).
installSharedSession();
// Browser errors are reported to our own server (God's Eye → Errors).
installClientErrors();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();